import { TableHeadCell } from "@shared/primitive-components"

export const safeMilesHeaderProps = {
  header: `Safe Miles`,
  tooltipContent: `The total number of miles spent driving within the speed limit of each area`,
}

export const SafeMilesHeader = () => <TableHeadCell {...safeMilesHeaderProps} />
